(() => {
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  document.querySelectorAll('[data-dialog-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const dialog = document.getElementById(button.dataset.dialogOpen);
      if (dialog && !dialog.open) {
        dialog.showModal();
        const initialFocus = dialog.querySelector('input:not([disabled])') || dialog.querySelector('button:not([disabled]), a[href]');
        initialFocus?.focus();
      }
    });
  });

  document.querySelectorAll('[data-dialog-close]').forEach((button) => {
    button.addEventListener('click', () => button.closest('dialog')?.close());
  });

  document.querySelectorAll('dialog[data-dialog]').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      const opener = document.querySelector(`[data-dialog-open="${dialog.id}"]`);
      opener?.focus();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll(focusableSelector)];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });

  const initializeProduct = (section) => {
    if (section.dataset.productInitialized === 'true') return;
    const variantsElement = section.querySelector('[data-product-variants]');
    const form = section.querySelector('.product-form');
    if (!variantsElement || !form) return;
    section.dataset.productInitialized = 'true';
    const variants = JSON.parse(variantsElement.textContent);
    const idInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const availability = section.querySelector('[data-product-availability]');
    const submit = section.querySelector('[data-add-to-cart]');
    const stickySubmit = section.querySelector('[data-sticky-submit]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    const selectMedia = (mediaId) => {
      if (!mediaId || ![...section.querySelectorAll('[data-media-id]')].some((media) => media.dataset.mediaId === String(mediaId))) return;
      section.querySelectorAll('[data-media-id]').forEach((media) => {
        const active = media.dataset.mediaId === String(mediaId);
        media.classList.toggle('is-hidden', !active);
        if (!active) media.querySelectorAll('video').forEach((video) => video.pause());
      });
      section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        const active = thumb.dataset.galleryThumb === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };
    const update = () => {
      const variant = variants.find((item) => String(item.id) === idInput.value);
      if (!variant) return;
      idInput.value = variant.id;
      const compare = variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : '';
      price.innerHTML = `${compare}<span>${formatMoney(variant.price)}</span>`;
      availability.textContent = variant.available ? 'Available' : 'Sold out';
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stickySubmit) { stickySubmit.disabled = !variant.available; stickySubmit.textContent = submit.textContent; }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      selectMedia(variant.featured_media?.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    idInput.addEventListener('change', update);
    section.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => selectMedia(thumb.dataset.galleryThumb)));


  };
  document.querySelectorAll('[data-product-section]').forEach(initializeProduct);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-product-section]').forEach(initializeProduct));

  document.querySelectorAll('[data-toc-source]').forEach((source) => {
    const container = source.parentElement.querySelector('[data-toc-container]');
    const toc = source.parentElement.querySelector('[data-toc]');
    const headings = [...source.querySelectorAll('h2, h3')];
    if (!container || !toc || headings.length < 2) return;
    const list = document.createElement('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link); list.append(item);
    });
    toc.append(list); container.hidden = false;
  });

  if (window.Shopify?.designMode) {
    const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

    const initializeHeroEditor = (hero) => {
      if (!hero || hero.dataset.heroEditorBound === 'true') return;
      const media = hero.querySelector('.hero__media');
      const toolbar = hero.querySelector('[data-hero-editor-toolbar]');
      if (!media || !toolbar) return;
      hero.dataset.heroEditorBound = 'true';

      const state = {
        desktop: {
          mode: hero.dataset.heroEditorDesktopMode,
          zoom: Number(hero.dataset.heroEditorDesktopZoom),
          width: Number(hero.dataset.heroEditorDesktopWidth),
          x: Number(hero.dataset.heroEditorDesktopX),
          y: Number(hero.dataset.heroEditorDesktopY)
        },
        mobile: {
          mode: hero.dataset.heroEditorMobileMode,
          zoom: Number(hero.dataset.heroEditorMobileZoom),
          width: Number(hero.dataset.heroEditorMobileWidth),
          x: Number(hero.dataset.heroEditorMobileX),
          y: Number(hero.dataset.heroEditorMobileY)
        }
      };
      const deviceLabel = toolbar.querySelector('[data-hero-editor-device]');
      const values = toolbar.querySelector('[data-hero-editor-values]');
      const activeDevice = () => window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
      const apply = () => {
        const device = activeDevice();
        const current = state[device];
        const prefix = `--hero-${device}`;
        hero.style.setProperty(`${prefix}-scale`, current.zoom / 100);
        hero.style.setProperty(`${prefix}-image-width`, `${current.width}%`);
        hero.style.setProperty(`${prefix}-custom-x`, `${current.x}%`);
        hero.style.setProperty(`${prefix}-custom-y`, `${current.y}%`);
        hero.style.setProperty(`${prefix}-custom-translate-x`, '-50%');
        hero.style.setProperty(`${prefix}-custom-translate-y`, '-50%');
        deviceLabel.textContent = current.mode === 'custom' ? `Editing ${device} position` : `Switch ${device} image display to Custom to edit`;
        values.textContent = `${device}: zoom ${current.zoom}% · width ${current.width}% · X ${Math.round(current.x)} · Y ${Math.round(current.y)}`;
        toolbar.querySelectorAll('button').forEach((button) => { button.disabled = current.mode !== 'custom'; });
      };

      let pointer = null;
      media.addEventListener('pointerdown', (event) => {
        const current = state[activeDevice()];
        if (current.mode !== 'custom' || event.button > 0) return;
        pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
        media.setPointerCapture?.(event.pointerId);
        hero.classList.add('is-editor-dragging');
        event.preventDefault();
      });
      media.addEventListener('pointermove', (event) => {
        if (!pointer || event.pointerId !== pointer.id) return;
        const rect = media.getBoundingClientRect();
        const current = state[activeDevice()];
        current.x = clamp(current.x + ((event.clientX - pointer.x) / rect.width) * 100, 0, 100);
        current.y = clamp(current.y + ((event.clientY - pointer.y) / rect.height) * 100, 0, 100);
        pointer.x = event.clientX; pointer.y = event.clientY;
        apply();
      });
      const finishDrag = (event) => {
        if (!pointer || event.pointerId !== pointer.id) return;
        media.releasePointerCapture?.(event.pointerId);
        pointer = null;
        hero.classList.remove('is-editor-dragging');
      };
      media.addEventListener('pointerup', finishDrag);
      media.addEventListener('pointercancel', finishDrag);

      toolbar.addEventListener('click', (event) => {
        const button = event.target.closest('[data-hero-editor-action]');
        if (!button) return;
        const current = state[activeDevice()];
        if (current.mode !== 'custom') return;
        if (button.dataset.heroEditorAction === 'zoom-in') current.zoom = clamp(current.zoom + 5, 50, 200);
        if (button.dataset.heroEditorAction === 'zoom-out') current.zoom = clamp(current.zoom - 5, 50, 200);
        if (button.dataset.heroEditorAction === 'reset') Object.assign(current, { zoom: 100, width: 100, x: 50, y: 50 });
        apply();
      });
      apply();
    };

    document.querySelectorAll('[data-hero-editor]').forEach(initializeHeroEditor);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-hero-editor]').forEach(initializeHeroEditor));
  }
})();
